import VueGtag from "vue-gtag";
import App from "./App.vue";

import { createHead } from '@unhead/vue'
import {createApp, provide} from 'vue'

import VueCookies from 'vue-cookies'

import DateTimeHelper from './common/DateTimeHelper.js';
import GoogleFontsHelper from './common/GoogleFontsHelper.js';
import DropzoneHelper from './common/DropzoneHelper.js';
import UrlHelper from './common/UrlHelper.js';
import emitter from './common/utilities/emitter.js';

//scss
import '../styles/main.scss';

//routers
import MainRouter from "./router/Router.js";

//store
import { store } from "./store/FolioStore.js";
import axios from "axios";
import { initAuth, installAuthInterceptor, keycloak, login, loginWithPassword, logout, migrateLegacyAuthState, register, requestPasswordReset, resetPassword, shouldInitializeAuth, signupWithPassword, startSocialLogin } from './auth/keycloakAuth.js';
import {PortfolioActions} from "./store/actions/PortfolioActions.js";
import globalMixin from "@/scripts/mixins/globalMixins.js";
import reviewStoreMixins from "@/scripts/mixins/reviewStoreMixins.js";
import { startSecurityMonitoring } from './monitoring/securityMonitoring.js';
import { isPrerenderedDocument } from './common/prerenderedDocument.js';

//App
export let app = null
export let router = null;

//directives
import zoomableDirective from './directives/zoomable.js';
import ResizableDirective from './directives/resizable.js';


app = createApp(App);
router = MainRouter;
app.use(router);
app.use(store);

// Register the mixin globally
app.mixin(globalMixin);
app.mixin(reviewStoreMixins);

app.config.globalProperties.$store = store;
app.config.globalProperties.$actions = PortfolioActions;
app.config.globalProperties.emitter = emitter;

//for injectin seo meta
const head = createHead();
app.use(head)

app.use(VueGtag, {
    includes: [
        //TODO: move out from here this is horrible.
        {id: process.env.NODE_ENV === "production" ? "G-SWXNNMMKPQ" : "G-TWMGEGKZCK"}
    ],
    config: {
        id:document.querySelector('meta[name="google-analytics-id"]').getAttribute('content')
    }
})

// Register global directive
app.directive('zoomable', zoomableDirective);
app.directive('resizable', ResizableDirective)

//Cookie handling
app.use(VueCookies, { expires: '7d'})

app.config.globalProperties.GoogleFontsHelper = GoogleFontsHelper;
app.config.globalProperties.UrlHelper = UrlHelper;
app.config.globalProperties.DateTimeHelper = DateTimeHelper;
app.config.globalProperties.DropzoneHelper = DropzoneHelper;
app.config.globalProperties.IsProduction = (process.env.NODE_ENV === 'production');

//stripe
const stripeKey = process.env.STRIPE_KEY_LIVE ? process.env.NODE_ENV === "production" ? process.env.STRIPE_KEY_LIVE : process.env.STRIPE_KEY_TEST : "pk_test_MJ8ele2xTDW4ASuXbRG1LPls0072k3oy96"
export const stripe = !!window.Stripe ? Stripe(stripeKey) : null;

//axios
axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

// Initialize security monitoring
startSecurityMonitoring();

migrateLegacyAuthState().catch((error) => {
    console.warn('Legacy auth cleanup failed', error);
});
installAuthInterceptor(axios);

// Tokens stay in memory. Protected routes and OAuth callbacks initialize auth
// through Keycloak SSO instead of restoring tokens from browser storage.
if (shouldInitializeAuth()) {
    initAuth();
}
window.uxfolioAuth = { keycloak, login, loginWithPassword, logout, register, requestPasswordReset, resetPassword, signupWithPassword, startSocialLogin };

// Mounting replaces the prerendered markup, so keep it on screen until the initial route
// (lazy chunk and guards) has resolved and Vue can render the page in one go.
if (isPrerenderedDocument) {
    router.isReady().catch(() => {}).then(() => {
        app.mount('#app');
        // Drops the pre-mount layout fallbacks (see public-pages/_general.scss)
        document.documentElement.removeAttribute('data-prerendered');
    });
} else {
    app.mount('#app');
}
